import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'
import { SectionHeading } from '@/components/shared/SectionHeading'
import { PhotoGrid } from '@/components/gallery/PhotoGrid'
import { SITE_NAME } from '@/lib/constants'

export function GalleryPage() {
  const { t } = useTranslation()

  return (
    <>
      <Helmet>
        <title>{`${t('gallery.title')} | ${SITE_NAME}`}</title>
        <meta name="description" content={t('gallery.subtitle') as string} />
      </Helmet>
      <section className="bg-cream-light pt-32 pb-20">
        <div className="mx-auto max-w-7xl px-4">
          <SectionHeading
            tagline={t('gallery.title')}
            title={t('gallery.title')}
            subtitle={t('gallery.subtitle')}
          />
          <PhotoGrid />
        </div>
      </section>
    </>
  )
}
